// eslint-disable-next-line no-restricted-imports
import { Form as AntForm } from 'antd';
import styled from 'styled-components';
import { DatePicker } from 'components/atoms/date-picker';
import { HelperText, Label, Label01, OutlineError } from 'components/styles';
import { Input } from '../input';
import { selectPrefix } from '../select';
import { RICH_TEXTAREA_EDITOR_CLASS } from './constants';
export const StyledForm = styled(AntForm)`
  .ant-form-item {
    padding-bottom: var(--layout-01);
  }

  .ant-form-item-control-input {
    margin-bottom: var(--spacing-02);
  }

  .ant-form-item-has-error {
    ${Input}.ant-input-affix-wrapper,
    ${Input}.ant-input,
    .ant-input-number {
      ${OutlineError};
      &:focus {
        box-shadow: none;
        ${OutlineError};
      }
    }
    .ant-form-item-extra {
      display: none;
    }

    .${RICH_TEXTAREA_EDITOR_CLASS} {
      border-bottom-color: transparent;

      .ck-editor__editable {
        ${OutlineError};
      }

      &:hover {
        --rte-background: var(--white-100);
      }
    }
  }

  .ant-form-item-has-feedback {
    .ant-input {
      padding-right: var(--input-height-default);
      &.ant-input-sm {
        padding-right: var(--input-size-sm);
      }
      &.ant-input-lg {
        padding-right: var(--input-height-lg);
      }
    }
    .ant-form-item-children-icon {
      width: var(--input-height-default);
    }
  }

  &.ant-form-small {
    .ant-form-item-has-feedback {
      .ant-form-item-children-icon {
        width: var(--input-size-sm);
      }
    }
  }

  &.ant-form-lg {
    .ant-form-item-has-feedback {
      .ant-form-item-children-icon {
        width: var(--input-height-lg);
      }
    }
  }

  .ant-form-item-label {
    ${Label};
  }
`;
const { Item } = AntForm;
const StyledItem = styled(Item)`
  .ant-form-item-label,
  .ant-form-item-label > label {
    ${Label};
    &.ant-form-item-required:not(.ant-form-item-required-mark-optional):before {
      ${Label01};
    }
  }

  .ant-form-item-explain,
  .ant-form-item-extra {
    ${HelperText};

    &.ant-form-item-explain-error {
      color: var(--error-color);
    }
  }

  &.ant-form-item-has-error {
    .${selectPrefix}__control {
      outline: 1px solid var(--error-color) !important;
      outline-offset: -1px;
    }

    ${DatePicker} {
      outline-color: var(--error-color);
    }
  }
`;
// Object.assign rather than an annotation + property assignment: styled-components 6.5
// rewrites a styled component's `style` prop, so the styled Item no longer satisfies the
// `Item` static hoisted off AntForm. Inferring the shape keeps both correctly typed and
// drops the `as any`. Runtime is unchanged.
const Form = Object.assign(StyledForm, {
    Item: StyledItem
});
export { Form };
